module.exports = __webpack_public_path__ + "static/media/icon10.9ea1145e.svg";